import FormatItem from '@/assets/formats/format-item'

// キャリア式
import ShokurekishoCareerEdit from '@/components/formats/ShokurekishoCareerEdit'
import ShokurekishoCareerPreview from '@/components/formats/ShokurekishoCareerPreview'
import ShokurekiCareerCards from '@/assets/formats/shokureki-career-cards'

// スキルシート
import ShokurekishoSkillsheetEdit from '@/components/formats/ShokurekishoSkillsheetEdit'
import ShokurekishoSkillsheetPreview from '@/components/formats/ShokurekishoSkillsheetPreview'
import ShokurekishoSkillsheetSample from '@/assets/formats/sample/shokurekisho-skillsheet-sample'
import ShokurekiSkillsheetCards from '@/assets/formats/shokureki-Skillsheet-cards'

import ShokurekishoEdit from '@/components/formats/ShokurekishoEdit'
import ShokurekishoPreview from '@/components/formats/ShokurekishoPreview'
// import ShokurekishoPreview from '@/components/formats/ShokurekishoPreviewSample'
import ShokurekishoSample from '@/assets/formats/sample/shokurekisho-sample'
import ShokurekiCards from '@/assets/formats/shokureki-cards'

import EnglishResumeEdit from '@/components/formats/EnglishResumeEdit'
import EnglishResumePreview from '@/components/formats/EnglishResumePreview'
import EnglishResumeSample from '@/assets/formats/sample/english-resume-sample'
import EnglishResumeCards from '@/assets/formats/english-resume-cards'

const formatsIndex = [
  // new FormatItem({
  //   id: 'keirekisho_job_change',
  //   title: '転職用の経歴書（JIS規格）',
  //   description: '令和２年７月からスタートした新様式です。日本工業規格（JIS）の規格に従ったA4サイズ2枚の一般的な履歴書テンプレートです。学歴・職歴の記入欄は比較的広めのつくりになっており、社会人経験が長い人にもおすすめです。',
  //   thumbnail: '/static/img/formats/rirekisho_job_change.png',
  //   images: [
  //     '/static/img/formats/sample/rirekisho_job_change_01.jpg',
  //     '/static/img/formats/sample/rirekisho_job_change_new_02.jpeg'
  //   ],
  //   newdetail1: 'A4サイズ/２枚',
  //   newdetail2: '令和２年７月からスタートした新様式',
  //   newdetail3: '社会人経験多めの方におすすめ',
  //   requiredBasicFields: ['name', 'furigana', 'birth', 'sex', 'address', 'addressFurigana', 'tel', 'email', 'contact', 'contactTel', 'contactEmail', 'photo'],
  //   hashs: ['履歴書'],
  //   components: {
  //     edit: RirekishoEdit,
  //     preview: RirekishoPreview
  //   },
  //   cards: RirekishoAddPreviewCards,
  //   sampleData: RirekishoSample,
  //   exampleSentences: jobChangeExampleSentences
  // }),

  new FormatItem({
    id: 'sales_shokumukeirekisho',
    title: '営業職の職務経歴書',
    description:
      '営業職向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。営業職向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '個人向け営業',
          sentences:
            '大学卒業後、20××年4月に株式会社○○に入社。保険商品の営業職として、企業における従業員への商品推進活動を行っております。\nお客様によって環境は様々である為、臨機応変に対応することで次のアポイントをいただき、新規加入者の増加につなげることができました。'
        },
        {
          type: 'others',
          name: '法人向け営業',
          sentences:
            '経験でアピール\n住宅メーカーの営業職として展示場を拠点とした営業活動に従事してきました。反響営業だけではなく地元不動産会社と連携したキャンペーンの実施や訪問型営業についても豊富な経験を有しております。'
        },
        {
          type: 'others',
          name: 'IT営業',
          sentences:
            'ソフトウェアベンダーにて約○年にわたり、主に製造業向けに基幹系システム・顧客管理システム及びそれに伴うインフラ構築の提案営業を行ってきました。直販による新規顧客・既存顧客への営業の他、代理店開拓・代理店への販促営業経験も有します。'
        }
      ],
      prMessage: [
        {
          type: 'others',
          name: '結果を出すための準備力をアピール',
          sentences:
            '１． 事前準備を徹底する\n私は担当企業以外にも、新規で自分から多くのお客様にお声をかけて保険の提案をさせていただきました。まだ若く、知識も浅い私は、常に資料を持ち歩き、質問を受けた際にすぐに対応し、お客様に有益な情報提供をすることで感謝の言葉を多くいただきました。\n２． 努力を怠らないこと\n担当企業へ訪問をする際、顔を覚えていただくために、毎日かかさず様々な営業先に訪問し、笑顔で接していました。また資格取得の勉強はもちろんのこと、日々のロールプレイングや上司とのミーティングも自ら積極的に取り組み、努力を重ねてきました。毎日決められたこと・自分自身で決めたことはきちんとやり抜きました。'
        },
        {
          type: 'others',
          name: '提案力をアピール',
          sentences:
            '現在までの５年間、戸建て注文住宅の営業職に従事してまいりました。新規顧客の開拓や価格の折衝、売上管理、事務処理など、主に営業関連業務の様々な経験を積む中で、自分自身の成長も感じてまいりました。注文住宅は購買者にとって夢のある、一生の（高額な）商品であり、納得して喜んで購入していただくものと考えます。そのためには様々な知識のみならず、挨拶から始まるお客様への対応が非常に大事である事を実感しています。お客様のニーズ・ご要望を引出し、的確な提案を仕掛けていくことは私の最も得意とする所です。'
        },
        {
          type: 'others',
          name: '熱意をアピール',
          sentences:
            '営業職の対応や熱意がクライアントの業者選定基準になりやすく、同業他社との差別化が難しい、人材派遣業界において常に意識していたことは、「訪問」「レスポンス」です。行動を意識することでクライアントからの高い信頼を得られていたと自負しております。また御用聞きにならないように、きちんとクライアントのニーズを理解し、積極的にこちらから提案を仕掛けるということを心掛けていました。この姿勢や取り組みをメンバーのときもマネジメントの立場でも実践することで高い実績を残してきました。'
        },
        {
          type: 'others',
          name: 'コミュニケーション能力をアピール',
          sentences:
            'コミュニケーション\n企画、デザイナー、生産管理、営業、販売など、他部署と積極的にコミュニケーションをとり、円滑に業務が遂行できるよう心掛けてきました。また、日本自のトレンドやマーケット情報を把握するため、本国との情報交換も定期的に実施してきました。'
        }
      ]
    }
  }),
  new FormatItem({
    id: 'shokumukeirekisho_type_career',
    title: 'キャリア式職務経歴書',
    description:
      '経験した業務や携わったプロジェクトを基準にして職務経歴書を書けます。',
    // description: 'A4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとに実績など一般的な項目が入力できます。転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    // thumbnail: '/static/img/formats/rirekisho_job_change.png',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: [
      // '/static/img/formats/sample/rirekisho_job_change_01.jpg',
      // '/static/img/formats/sample/rirekisho_job_change_02.jpg'
      '/static/img/formats/sample/shokurekisho.png'
    ],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    // requiredBasicFields: ['name', 'email'],
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['キャリア式職務経歴書'],
    components: {
      edit: ShokurekishoCareerEdit,
      preview: ShokurekishoCareerPreview
    },
    // cards: RirekishoCards,
    cards: ShokurekiCareerCards,
    sampleData: ShokurekishoSample,
    // exampleSentences: jobChangeExampleSentences
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: 'はじめての転職',
          sentences:
            '大学卒業後、株式会社XXに入社。XX事業部・XX職として配属されました。主にXXを担当し、XXに関する業務やXXに携わってきました。'
        },
        {
          type: 'others',
          name: '2社の転職を経験',
          sentences:
            '大学を卒業後、新卒でXX会社に入社しXX職としてXX業界のXXに携わりました。2社目のXX社ではXX職としてXXやXXを担当、XXの経験を積みました。'
        },
        {
          type: 'others',
          name: '複数社の転職を経験',
          sentences:
            '大学を卒業後、XX会社のXX職をX年勤めたのち、XX会社のXX職やXX会社のXX職を経験。20XX年より株式会社XXに入社し、XX職として勤務。主にXXに従事し、XXやXXの業務を担当しています。'
        }
        // {type: 'others', name: 'エンジニア', sentences: '大学を卒業後、ソフトウェア開発会社に入社。一貫して金融業界の業務システム開発に携わる。1社目ではシステムエンジニアとしてプログラム基本設計から開発、テストをｘ年担当後、プロジェクトリーダーとしてプロジェクトの進捗管理を担当。2社目のシステムインテグレーターでは、加えて顧客折衝の経験を積む。'},
        // {type: 'others', name: '営業', sentences: '大学を卒業後、求人情報サイトを運営する株式会社◯◯に入社。営業職として、新規顧客の開拓を中心に取り組んでおりました。直近3年間は毎年目標売上を達成、昨年は120％達成により社内賞も受賞しました。チームリーダーを任されており、3名のチームメンバーの業績管理の経験もあります。'},
        // {type: 'others', name: '事務', sentences: '株式会社〇〇において、営業事務として5年間従事。営業担当8名の営業資料や契約書類の作成に加え、電話対応・来客対応・精算業務などに携わってきました。商品の知識を深めて営業担当とコミュニケーションをとることで、バックオフィスとの連携が円滑に回るようになり売上向上につながったと評価をいただきました。また、業務フローの整備や書類作成の簡略化など日々の業務の効率化にも取り組み、会社に貢献してきました。'},
        // {type: 'others', name: 'その他', sentences: '大学卒業後、株式会社〇〇に入社。XXといった業務に携わってきました。社外との折衝業務が多く、社内・外を問わず円滑なコミュニケーションを心掛けてきました。在職中はxxxxの資格を取得し、現在xxxxのスペシャリストを目指して勉強しております。今後は前職の経験を活かし、短期間で貴社の戦力となれるよう努力いたします。'}
      ],
      prMessage: [
        {
          type: 'others',
          name: 'スキルをアピール',
          sentences:
            '現職にてXXを目的としたXXに関わり、実務経験を積んできました。新しい技術や情報についても積極的に勉強し、チームのメンバーも交えて情報共有しながら実務で活かすように取り組んでいます。'
        },
        {
          type: 'others',
          name: '同業種・業界での経験をアピール',
          sentences:
            '現職では、XXメーカーのXX業務に長年携わっていました。ターゲットであるXXに適したXXなどの施策を実施し、前年対比XXX％の売上を達成しました。今までに学んできたXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
        },
        {
          type: 'others',
          name: 'マネジメント経験をアピール',
          sentences:
            '現職にてマネージャーをX年間経験しまし、社員が互いに刺激を与え合いながら成長していく組織作りに注力してきました。結果、社員同士の意識が目標に対して統一され、速やかな数値達成ができました。柔軟な対応力とXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
        },
        {
          type: 'others',
          name: '事務能力の高さ・効率性をアピール',
          sentences:
            'ケアレスミスをなくし、常に効率改善の余地がないか考えながら業務に取り組むように心がけています。現職では業務フローの見直しや日々の書類業務の自動化を主導しまし、全体の作業時間をXX％短縮させることに成功しました。特にXX関連業務の書類・ドキュメント作成の経験が豊富なことが強みです。'
        },
        {
          type: 'others',
          name: '意欲・熱意をアピール（実務未経験）',
          sentences:
            'XXがきっかけでXXという仕事に魅力を感じ、XXスクールやXX講座に通い自主的に勉強を続けてきました。今回、実務経験がなくても熱意や意欲次第で採用を検討されていると拝見し、応募をさせていただきました。未経験ではありますが、XXに関する知識やスキルを高める努力をしながら貴社の事業に貢献したいと考えています。'
        }
        // {type: 'others', name: 'エンジニア', sentences: '開発経験が豊富です。現職にて自社運営サイトのアクセス増加を目的とした新規機能開発に携わりました。サーバーサイドを担当し高速化・効率化を実現してきました。実務でのプログラミング経験から得た知識に加え、最近はプライベートでandroidアプリケーションの開発も行いました。新しい技術に関しても積極的に取り組んでいきます。チームマネジメント経験があります。少人数ながらチームリーダーを担当しました。メンバー間のコミュニケーションを重要視して円滑な進捗はもちろん、職務を通して全員がスキルアップしながら開発が行えるようマネジメントを心掛けました。'
        // },
        // {type: 'others', name: '営業', sentences: '前職では、エリアマネージャーを計5年経験しました。売上目標達成のため、店舗ごとに定期的に分析を行いKPIを設定。メンバーにはKPIとして設定したプロセスを完遂することを要望しました。その結果、目標を全て達成。売上目標も当初から20%増と推移し、非常に高い成果を残すことができました。扱う商材は変わりますが、お客様や店舗の状況を調査し戦略を立てた経験や、多数のメンバーのマネジメント経験は、貴社でも活かせるものと思います。'},
        // {type: 'others', name: '事務', sentences: '期限を守った上でミスなく確実にドキュメント作成を行ってきました。ダブルチェックを徹底し責任をもって仕事を仕上げます。また、常に効率改善の余地がないか考えながら日々の業務に取り組みます。前職では業務フローの見直しや日々の書類業務の自動化を主導し、全体の作業時間を大幅に短縮させることに成功しました。事務能力を活かして貴社に貢献したいと考えております。'},
        // {type: 'others', name: 'その他', sentences: '前職にてマネージャーを3年間経験しました。社員が互いに刺激を与え合いながら成長していく組織作りに注力してきました。結果として社員同士の意識が目標に対して統一され、速やかな数値達成ができました。柔軟な対応力と〇〇の経験を活かして、必ず貴社でお役に立てるものと考えております。何事も素直に吸収していけるよう、努力する気持ちを忘れずに頑張ります。'}
      ]
    }
  }),
  new FormatItem({
    id: 'skillsheet_type',
    title: 'スキルシート',
    description:
      '基本的なスキルシートのテンプレートです。スキルや経験をまとめて記載することができます。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/skillsheet.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['スキルシート'],
    components: {
      edit: ShokurekishoSkillsheetEdit,
      preview: ShokurekishoSkillsheetPreview
    },
    cards: ShokurekiSkillsheetCards,
    sampleData: ShokurekishoSkillsheetSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: 'はじめての転職',
          sentences:
            '大学卒業後、株式会社XXに入社。XX事業部・XX職として配属されました。主にXXを担当し、XXに関する業務やXXに携わってきました。'
        },
        {
          type: 'others',
          name: '2社の転職を経験',
          sentences:
            '大学を卒業後、新卒でXX会社に入社しXX職としてXX業界のXXに携わりました。2社目のXX社ではXX職としてXXやXXを担当、XXの経験を積みました。'
        },
        {
          type: 'others',
          name: '複数社の転職を経験',
          sentences:
            '大学を卒業後、XX会社のXX職をX年勤めたのち、XX会社のXX職やXX会社のXX職を経験。20XX年より株式会社XXに入社し、XX職として勤務。主にXXに従事し、XXやXXの業務を担当しています。'
        }
      ],
      prMessage: [
        {
          type: 'others',
          name: '担当の幅のアピール',
          sentences: 'プロジェクト全体のフェーズに一貫して関わっていました'
        },
        {
          type: 'others',
          name: 'マネジメント経験をアピール',
          sentences:
            '現職にてマネージャーをX年間経験しまし、社員が互いに刺激を与え合いながら成長していく組織作りに注力してきました。結果、社員同士の意識が目標に対して統一され、速やかな数値達成ができました。柔軟な対応力とXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
        },
        {
          type: 'others',
          name: '開発範囲のアピール',
          sentences: '〇〇ソフトウェアの開発にも積極的に参加してきました。'
        }
      ]
    }
  }),
  new FormatItem({
    id: 'service_shokumukeirekisho',
    title: '販売・サービス職の職務経歴書',
    description:
      '販売・サービス職向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。販売・サービス職向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '販売・接客',
          sentences:
            '学生時代のアルバイトを含めると○年間アパレルの小売業での経験があります。20xx年からは副店長、20xx年には店長としてスタッフの採用管理から売り上げ管理まで店舗経営担当としての業務全般に携わってきました。店舗独自の顧客管理手法の開発（現在全社で導入）やイベントプロモーションなど売り上げ促進のさまざまな営業施策の企画実施経験もあります。'
        },
        {
          type: 'others',
          name: '店長・SV',
          sentences:
            '○年間の店舗経験（副店長、店長を経験）のあと○年○ヶ月SVとして兵庫、北海道エリアを担当してまいりました。SVとしてはFC店舗だけでなく、直営店を担当。また新任SVの教育や直営店の店長研修なども担当しました。'
        },
        {
          type: 'others',
          name: 'バイヤー/MD',
          sentences:
            'アパレル商社にて、海外ブランド製品のバイヤー/MD担当として、マーケット環境や担当ブランドの売上予測や計画立案、商品計画、コスト管理、売場への展開まで幅広く携わってまいりました。また、国内オリジナル商品の企画などにも関わっております。'
        }
      ],
      prMessage: [
        {
          type: 'others',
          name: '視野の広さをアピール',
          sentences:
            '<物事を「経営的視点で捉える」>\n地域にあった改善策を各店舗と協力体制のなかで実施するなど全社の決定事項を一律に実施するだけでなく、常に状況を把握し、改善する打ち手を考えてきました。また、数値目標に対する達成意欲と、目標達成に向かって戦略的に考える思考を養いました。'
        },
        {
          type: 'others',
          name: '組織構築力をアピール',
          sentences:
            'メンバーが当事者意識と目標達成意欲を持てる組織づくり\n・販売数量/販売実績などの経営情報を目的から共有しながら「やらされ感」ではなく目標にこだわる「能動的に動く」チームづくりに取り組んできました。'
        },
        {
          type: 'others',
          name: '企画提案力をアピール',
          sentences:
            '企画提案\n実績データの分析を通して、「次はどのような提案ができるか」ということを常に意識し、行動をとってきました。具体的には、日本独自のトレンドやマーケットを意識した商品をライセンスで開発したり、イベントを立案しDMを作成したりと、様々な角度からアプローチを続けてまいりました。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'plan_shokumukeirekisho',
    title: '企画職の職務経歴書',
    description:
      '企画職向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。企画職向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '事業企画',
          sentences:
            '大学卒業後、株式会社XXXへ入社。マーケティング・商品開発部門に約X年従事し、商品企画から広告及び関連領域全般にわたる業務を経験しました。20XX年よりプロダクトマネージャーとして、商品企画・導入・プロモーションなどプロダクトの管理業務を担当。人材の育成も積極的に行い、業務管理などを通じてマネジメント力も養いました。今後は経験を発揮して、経営企画などの更なるステップアップを目指しています。'
        },
        {
          type: 'others',
          name: '経営企画',
          sentences:
            '株式会社○○○○○に入社後、経営企画部に配属され、主に海外子会社などのグループ会社を含めた財務分析や予算編成などを行っています。20xx年からは中長期計画策定などの業務にも携わり、新規事業の検討からM＆A戦略の策定なども担当。また、期初計画にない課題に対してのプロジェクトも担当し、課題解決を通して事業拡大に貢献しています。'
        },
        {
          type: 'others',
          name: '営業企画',
          sentences:
            '株式会社○○○○○に入社後、化粧品を取扱う店舗への営業を約x年間担当。20xx年からは営業企画部に異動となり、インバウンドマーケティングの強化や社内ツール導入など、営業の効率化やコスト削減、業務改善のプロジェクトに取り組んできました。インバウンドマーケティングの強化では、SNSを駆使した情報提供やメッセージ配信施策によりリピート率向上に貢献。また、社内ツール導入による社内連携の円滑化にも携わっています。'
        }
      ],
      prMessage: [
        {
          type: 'others',
          name: '推進力をアピール',
          sentences:
            '＜各部署と連携してプロジェクトを動かす推進力＞\n海外への事業展開プロジェクトを、営業や物流企画、商品企画部門など各部署と連携して進行させました。プロジェクトのリーダーとして全体のスケジュールや進捗管理を担当。営業や物流部門からの現地調査報告を基に、拠点の選定や販売戦略を策定し、最終的な企画をまとめた上で経営層への報告を実施するなど、チームメンバーを動かしながら責任の大きい仕事を遂行してきました。結果として、海外展開に成功し、その後の拠点増加にも貢献しています。'
        },
        {
          type: 'others',
          name: '対応力をアピール',
          sentences:
            '<新規事業展開のための幅広い対応力>\n本社だけでなく、海外子会社の業績管理や予算編成も行っています。社長や役員に同行し、経営会議の通訳や資料作成なども担当。また、M＆A後の環境整備などを徹底し、IT部門と連携してシステムやインフラの構築などを図りました。また、新規ビジネスのスムーズな稼働の実現のため、統合先の企業において現場レベルからビジョンやノウハウの共有を行い、目標に対しての認識の統一を実施。結果として、統合効果の最大化に貢献しています。'
        },
        {
          type: 'others',
          name: '施策実行力のアピール',
          sentences:
            '＜データを用いた施策実行力＞\nデータを分析し、課題解決のために施策を打てることが私の強みです。売り上げの伸びが鈍化していたため、市場調査や売り上げデータを分析したところ、商品をリピートする顧客が減少している課題を発掘しました。そこで、解決策として、SNSを活用したメッセージ配信や情報提供により顧客のファン化を促進する施策を実施することにしました。お客さまが各店舗でLINE公式アカウントに登録したあと、新商品情報やクーポンを配信するキャンペーンを行ったことで、リピート率を向上させることに成功し、売り上げが前年比でxx％増加しました。また、DMコスト年間約xxx万円の削減にも貢献できました。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'webdesign_shokumukeirekisho',
    title: 'Webデザイナーの職務経歴書',
    description:
      'Webデザイナー向けのA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。Webデザイナー向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            'Webデザイナー20名規模の制作会社に所属し、クライアントの販促やキャンペーンサイトの制作に携わってきました。デザイン・コーディング経験とともに、クライアントへの企画提案や外注スタッフの制作ディレクションも経験。'
        },
        { type: 'others', name: '', sentences: '' },
        { type: 'others', name: '', sentences: '意欲をアピール' }
      ],
      prMessage: [
        {
          type: 'others',
          name: 'クライアントへのヒアリングを徹底して行い、関係性を構築することによって１回で承認をいただけるような満足度の高いデザインプレを心がけています。また、クライアントの目標とユーザビリティの両立にこだわり、手掛けたサイトはすべて目標を達成することができました。初速が思わしくない場合はすぐに早期改善提案を行うなど、クライアントから指摘される前に動くことがこだわりです。\n\n出し戻しの工数を減らし、後手に回らない提案を行うことで業務時間の効率化を図り、退社後はフロントエンドの技術力を高めるために月に4～6回程度は勉強会に通っています。勉強会で得た知識やスキルは、今後の提案や制作物に活かしていきたいと考えています。',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'nurse_shokumukeirekisho',
    title: '看護師の職務経歴書',
    description:
      '看護師向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。看護師向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            '内科やケア業務などの看護師として常時○○床～○○床の看護業務に従事してきました。病院内入院患者の看護のほかに緊急患者の対応や訪問看護の経験もあります。'
        },
        { type: 'others', name: '', sentences: '' },
        { type: 'others', name: '', sentences: '意欲をアピール' }
      ],
      prMessage: [
        {
          type: 'others',
          name: '積極的に自ら行動し、必要だと感じましたら努力を惜しまず、経験・勉学に励んできました。\n介護・看護の両面から物事を見ることができると思います。また、身体面だけでなく精神面も学んでまいりましたので、あらゆる場面でその経験を活かせると思います。興味をもったこと、必要だと感じたことには積極的に学習し、経験を積もうという意欲があります。',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'marketing_shokumukeirekisho',
    title: 'マーケティング職の職務経歴書',
    description:
      'マーケティング職向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。マーケティング職向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '商品企画・販売促進',
          sentences:
            '株式会社○○○○○に入社後、主に大手保険会社や自動車メーカー、化粧品メーカー、食品メーカーに対して、販売促進のための施策やイベントを企画しました。企画にあたっては、顧客の商品やサービスの認知拡大、販売促進に最適なメディアや手法を選定しています。オフラインからオンラインまで幅広く扱い、柔軟な企画で顧客ビジネスに貢献しました。'
        },
        {
          type: 'others',
          name: 'PR・広告・宣伝',
          sentences:
            '株式会社○○○○○に入社後、主に大手製薬会社やファッションブランド、自動車などの顧客を対象にリスティング広告やディスプレイ広告、SNS広告の運用を約x年間経験しました。また、メディアプランの設計や施策の提案も行い、Web広告マーケティングの幅広い業務を担当しました。現在は、案件対応だけでなく、チームメンバーxx人のマネジメントも行い、チーム内の各案件の品質担保に努めています。'
        },
        { type: 'others', name: '', sentences: '' }
      ],
      prMessage: [
        {
          type: 'others',
          name: '企画力をアピール',
          sentences:
            '＜最適なターゲット選定と企画力＞\n自動車メーカーのファミリーカーの新型モデル発表にあたり、認知拡大施策として商業施設内で展示イベントを企画しました。購入者は世帯主である男性が中心で、これまでは男性向けのキャンペーンを行っていました。しかし、データから配偶者の女性や、子どもの意見が購入動機になるケースが増えていることが分かったため、会場を家族連れが訪れる場所に設定しました。そして、ターゲットに合わせて子どもが長時間滞在できるようなコーナーを設置するなど工夫しました。また誘致するメディアもターゲットに合ったものを選定し、露出を高めることを狙いました。\nその結果、イベントの来場者数が目標数を達成しただけでなく、想定よりも多くのメディア露出ができたことで、潜在顧客の興味喚起につなげることに成功。最終的に、店舗への来店者数目標をxx％上回ることができました。'
        },
        {
          type: 'others',
          name: '課題分析力と適切な対応力をアピール',
          sentences:
            '＜課題分析力と適切な対応力＞\n食品メーカーにおいて、○○部門全体の売り上げシェアxx％を占める主力商品である○○の売り上げが減少しており、クライアントから販促施策の相談を受けました。メーカー側の担当者と過去の売り上げデータや市場調査のデータをもとに原因を分析したところ、認知度は高いものの、他の商品と比較して購入頻度が下がっていることが課題と分かりました。そこで、販売促進のためジオターゲティングを活用し、コンビニ付近にいるユーザーをターゲットに、SNSを通して対象商品のクーポンを配信しました。その結果、前年同月比xxx％の売り上げ拡大に貢献しました。'
        },
        {
          type: 'others',
          name: 'マネジメント力をアピール',
          sentences:
            '＜案件の進行におけるマネジメント力＞\nファッションブランドを担当し、リスティング、ディスプレイ、SNS広告運用のプロジェクトマネジャーを務めました。公式サイト経由での獲得数月間xxx件というKPI達成のため、各メディアへの予算配分や運用方針を計画。各媒体の運用担当者と日々成果や進捗を確認しながら調整しました。また、広告クリエイティブの効果検証なども行い、効果的なクリエイティブを検討。結果として、KPIをxxx％で達成し、売り上げ拡大に貢献しています。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'engineer_shokumukeirekisho',
    title: 'SE・IT系技術職の職務経歴書',
    description:
      'SE・IT系技術職向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。SE・IT系技術職向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: 'SE（システムエンジニア）',
          sentences:
            '・20xx年xx月～現在　　　　　株式会社△△△△　　外資自動車部品、大手カメラメーカーに常駐し組込みソフトのリーダーとして◯年従事。\n・20xx年xx月～20xx年xx月　○○○○株式会社　　工作機械、携帯端末メーカーに常駐し組込みソフトの設計、プログラミング、テストを◯年経験　'
        },
        {
          type: 'others',
          name: 'ITコンサルタント',
          sentences:
            '大学卒業後ITコンサルティングファームに入社、電気メーカーをクライアントとし、製造業におけるグローバルサプライチェーンの製販・購買及び会計（債権債務管理）領域のBPR、システム導入を行って参りました。'
        },
        {
          type: 'others',
          name: 'インフラエンジニア',
          sentences:
            '200x年xx月～20xx年xx月：○○○○株式会社\n20xx年xx月～現在：株式会社△△△△　現在インフラ系PM補佐として従事'
        }
      ],
      prMessage: [
        {
          type: 'others',
          name: '開発スキルをアピール',
          sentences:
            '<実装開発スキルについて>\n主にJavaやPHPを中心としたWebアプリケーションの開発を経験しています。Struts/Springといったフレームワークを使用しての開発経験もありますので、Javaについてはかなり深いレベルでの知識を有していると自負しております。Rubyやその他最新の技術についても常にアンテナをはってエンジニアとしての研鑽に日々励んでおります。\n<効率と品質を意識したシステム開発>\n若手ということもあり、限られた範囲での作業でしたが、納期内で指示されたシステムを納めるのは当たり前という考えのもと、少ないリソースで最高のパフォーマンスを発揮できるよう作業に取り組んできました。例外ロジックやDB 接続、ログ出力などを共通部品化、隠蔽するなど率先して取り組み、チーム全体の作業効率化、高品質化を実現しました。また、成果物に関しては、上司や他のメンバーにレビューをお願いする前に必ずセルフチェックを行い、作業品質の向上、工程の後戻りを防止するようにも努めてまいりました。'
        },
        {
          type: 'others',
          name: '業務改善提案経験をアピール',
          sentences:
            '新卒で入社以来、製造業を中心としてコスト削減を中心としたBPR、システム企画のプロジェクトに携わってまいりました。その中で顧客が当初課題と捉えていた内容以外にも、様々な分析をすることで、新たな課題点を抽出し、解決提案をすることで、満足度の高いサービス提供を行い、顧客からも高い評価を得ております。\n今後は、これまでに培ってきました業務改善提案経験及びシステム導入、プロジェクト管理経験を活かし、より大きなステージで、企業の経営課題の解決を図っていきたいと考えております。'
        },
        {
          type: 'others',
          name: '<顧客折衝力>\n顧客やメンバーとのダイレクトコミュニケーションを心掛けることでミスマッチを防ぐようにしております。提案や要件定義などの前工程において情報共有化を徹底することが、後工程の無駄な障害やコストの削減につながると考えております。',
          sentences: 'プロジェクトマネジメント力をアピール'
        },
        {
          type: 'others',
          name: 'プロジェクトマネジメント力をアピール',
          sentences:
            '<プロジェクトマネジメント>\n自社ならびにパートナー企業社員の混成チームにおけるマネジメント経験を有しています。これまでコスト、スケジュール、タスク、品質などの管理業務を行ってきました。また、ステアリングコミッティ、マイルストーンなどをプロジェクトごとに適切に設け、プロジェクトバーストを未然防止に尽力してきました。'
        }
      ]
    }
  }),
  new FormatItem({
    id: 'electric_shokumukeirekisho',
    title: '電気・機械系技術職の職務経歴書',
    description:
      '電気・機械開発系向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。電気・機械開発系向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '電子回路設計',
          sentences:
            'バイクのエンジン部品のCAEによる設計支援を○年○か月行ってきました。機械的な性能向上だけではなく、樹脂パーツを使う場合は物性・成形面からもみた生産効率向上の提案をするなど幅広く経験してきました。○年○月からはグループリーダーとしてメンバーのマネジメント業務にも携わっております。'
        },
        {
          type: 'others',
          name: 'LSI設計',
          sentences:
            '××大学×××学部を卒業後（卒業研究テーマ『×××××××』）、××××株式会社にて約×年デバイスの試験、測定機器開発業務に従事。\n\nアナログ・デジタル・高周波回路の設計を行う。その後、レイアウト設計を経験。デジタル、アナログ両方の経験をし、プロジェクトマネージャーとして新規製品開発経験も担当し、現在に至る。'
        },
        {
          type: 'others',
          name: '制御ソフト',
          sentences:
            '・20xx年xx月～現在　　　　　株式会社△△△△　　外資自動車部品、大手カメラメーカーに常駐し組込みソフトのリーダーとして◯年従事。\n・20xx年xx月～20xx年xx月　○○○○株式会社　　工作機械、携帯端末メーカーに常駐し組込みソフトの設計、プログラミング、テストを◯年経験　'
        }
      ],
      prMessage: [
        {
          type: 'others',
          name: '知識と経験をアピール',
          sentences:
            '完成バイクメーカーを中心にバイク業界約○○社に対し、CAEによる設計支援を行ってきました。この経験を活かして、顧客より要求される解析結果はもとより、改善提案まで迅速に提供することで、設計スピードの向上・製品性能の向上に貢献できると思います。また、樹脂を使用するパーツにおいては、樹脂メーカーとの協業によって得られた物性・成形の知識を活かして、機械的な性能向上だけではなく、生産効率向上も可能な設計提案を行えると考えています。'
        },
        {
          type: 'others',
          name: '実装開発スキルをアピール',
          sentences:
            '<実装開発スキルについて>\n下層レイヤにおいては、メモリ不足を補うため、通信シーケンスも開発。ディスクリート構成からワンチップIC まで幅広く技術を習得し、要素開発・量産開発までを行う。ドライバなど、ハードウェアに近いモジュールの開発だけでなく、CPUアーキテクチャや制御対象ハードウェアの構造理解を前提とした開発経験があります。また、機能レイヤでは、Struts/Springといったフレームワークを使用しての開発経験もありますので、Javaの知識を有していると自負しております。'
        },
        {
          type: 'others',
          name: 'アナログとデジタルの経験をアピール',
          sentences:
            '<アナログからデジタルまで一貫して携われます>\nデバイスの試験、測定機器開発業務においてアナログ・デジタル・高周波回路の設計まで一貫して携わった経験があります。また、自動車部品メーカーにて、マイコンを用いた制御回路の設計にも従事してまいりました。'
        },
        {
          type: 'others',
          name: 'コミュニケーション能力をアピール',
          sentences:
            '<相手の立場に立ったコミュニケーション>\n特にユーザー折衝、開発メンバーへの技術指導を行う上で、より良い人間関係を構築できるよう努めてまいりました。ユーザーとの折衝においては、いきなり自分の意見を述べるのではなく、まず、ユーザーの意見を十分に聞いた上で一緒に考え、最適な解が出せるよう努めてきました。開発メンバーへの技術指導については開発に必要な業務知識から説明することにより、メンバーが納得感、参画意識をもって開発に従事できるように心がけました。こうしたスタンスでのコミュニケーション方法は、私の今後のキャリア形成においても様々なフェーズで活きてくると思っております。'
        }
      ]
    }
  }),
  new FormatItem({
    id: 'finance_shokumukeirekisho',
    title: '経理の職務経歴書',
    description:
      '経理向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。経理向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            '○年○ヶ月経理部門にて帳票作成から監査対応まで経理実務に携わってまいりました。ほかにもシステム導入による業務改善全般や現在は課長としてメンバーマネジメントも経験しております。'
        },
        { type: 'others', name: '', sentences: '' },
        { type: 'others', name: '', sentences: '' }
      ],
      prMessage: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            '現場では仕事に恵まれ、若手のうちから子会社の経理全般や連結決算を一人でやらせていただきました。現在は、管理職として、先輩社員、新入社員を含めた7名の部下の指導・育成に努めております。また、変わっていく税制に対応するために、税理士資格取得を目指しており、日々その勉強を欠かしません。今後は、私の経験が活かせる新たなフィールドで研鑽を積みたいと考えております。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'hr_shokumukeirekisho',
    title: '人事の職務経歴書',
    description:
      '人事向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。人事向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            '2社にて通算○年○ヶ月間、労務管理から採用教育まで人事業務全般について制度の企画立案から運用や組合交渉まですべての工程を経験してまいりました。特に採用・教育関連業務については自信をもっております。'
        },
        { type: 'others', name: '', sentences: '' },
        { type: 'others', name: '', sentences: '' }
      ],
      prMessage: [
        {
          type: 'others',
          name: 'リーダー経験をアピール',
          sentences:
            '会社をあげた新人事制度導入プロジェクトにおいてはリーダーとして業務を実施してきました。外部コンサルタントや経営幹部とともに作業に当たる中で、何が本質的な課題なのか、ゴールイメージは何かを常に意識し、議論を集約していくことを常に意識してきました。人事業務は、事業目的を果たすために、貴重な人的リソースの力を最大にしていくことだと考えています。今後は、前職で培った人事に関する制度設計からシステム導入までの幅広い知識を活かしつつ、より事業全体までを視野に入れた人事業務ができるよう力をつけていきたいと思います。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'affairs_shokumukeirekisho',
    title: '総務の職務経歴書',
    description:
      '総務向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。総務向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            '備品・什器やファシリティのマネジメント、株式関連業務や各種契約文書から就業規則の見直しや福利厚生の改善企画まで、成長過程にある上場ベンチャー企業の一員として総務部門でありながらも部署名に限定されない会社運営にかかわる場面全般に関わってまいりました。'
        },
        { type: 'others', name: '', sentences: '' },
        { type: 'others', name: '', sentences: '' }
      ],
      prMessage: [
        {
          type: 'others',
          name: '調整力をアピール',
          sentences:
            '備品管理から株式関連まで、総務に関する幅広い経験をしてきました。特にISO14001,ISO15001やプライバシーマークの導入においては、関連部署の数が非常に多く、事務局としての調整に非常に苦労しました。そこでの経験を通じて大きな調整力が身についたと思っております。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'office_shokumukeirekisho',
    title: '一般事務職の職務経歴書',
    description:
      '一般事務職向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。一般事務職向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            '株式会社○○○○○に入社後、営業事務として営業のアシスタント業務に従事しています。主に受発注業務を担当し、並行して見積書、請求書、契約書などの各種書類を作成。また、営業が行うレポーティング業務の効率化や新入社員教育などで使用する事務作業マニュアルの作成などに取り組み、営業活動の円滑化や教育、事務作業の正確性向上に貢献しています。'
        },
        { type: 'others', name: '', sentences: '' },
        { type: 'others', name: '', sentences: '' }
      ],
      prMessage: [
        {
          type: 'others',
          name: 'サポート力をアピール',
          sentences:
            '＜営業活動を円滑にするためのサポート力＞\nアシスタントとして、営業担当が営業活動に注力できるように業務改善に取り組みました。営業担当が行うレポーティング作業をマクロの活用により効率化し、事務作業にかかる工数を短縮。また、新しい営業担当や事務担当の教育用資料の作成などを行い、新入社員がすぐに作業に取りかかれるような環境づくりに注力しました。結果として、営業担当の保有案件数が1人当たり平均x件増加しました。'
        },
        {
          type: 'others',
          name: '書類作成、データ入力、コミュニケーションスキルをアピール',
          sentences:
            '5年間の事務経験を経て培った、請求書などの各種書類の作成スキルやデータ入力の知識・正確性は、貴社の事務職としても役立てられるものと考えております。PCスキルにつきましてはWordやExcelなどの基本的なPCスキルは網羅しており、2018年2月にはMicrosoft Office Specialist　Excel 365&2016に合格しました。\nこのスキルを活かしながら、貴社でも早期に戦力としてお役に立てるよう努めたいと考えております。'
        },
        {
          type: 'others',
          name: '調整力をアピール',
          sentences:
            '＜営業担当や他部署との調整力＞\n営業担当が不在の間、顧客からの問い合わせや他部署からの依頼に適切な対応を行い、正確に営業担当に引き継げるように心掛けています。営業担当への引き継ぎの際は、引き継ぎ用のメールフォーマットを作成しメールで共有した上で、帰社後にも口頭での伝達を実施。結果として、顧客や他部署からの質問や依頼などへの漏れのない対応を実現できています。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'legal_shokumukeirekisho',
    title: '法務の職務経歴書',
    description:
      '法務向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。法務向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            '○ヶ月まで法律事務所でのパラリーガル業務を経て、現在は○年○ヶ月企業内法務として訴訟、M&A、株主総会など特に海外法務、知的財産分野における戦略法務全般に携わってまいりました。'
        },
        { type: 'others', name: '', sentences: '' },
        { type: 'others', name: '', sentences: '' }
      ],
      prMessage: [
        {
          type: 'others',
          name: '知識と思考力をアピール',
          sentences:
            '大学で法学部を卒業し、憲法、刑法、民法について基礎知識と法的な思考力を身につけております。職務経歴としては、各種契約から訴訟、M&A、株主総会等、特に海外法務に関する幅広い経験をしてきました。今後、さらに法務としての職務経験を積み、コンプライアンスなど戦略法務としても力をつけていきたいと思っています。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'ir_shokumukeirekisho',
    title: '広報IRの職務経歴書',
    description:
      '広報IR向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。広報IR向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            '上場を控えたベンチャー企業の経営企画部門にて、社外広報業務全般を手がけてまいりました。JASDAQ市場への公開に向けた準備から上場後のIR活動まで、インターネットを活用したメディアによる広報活動と工場見学会などの直接交流を持つ機会とを両立しながら株主、投資家やマスコミへの広報や良好な関係構築に努めてまいりました。'
        },
        { type: 'others', name: '', sentences: '' },
        { type: 'others', name: '', sentences: '' }
      ],
      prMessage: [
        {
          type: 'others',
          name: 'プレスリリース経験をアッピール',
          sentences:
            '広報担当として、社外からの問い合わせにすぐに対応できるよう、常時社内外の情報収集には努めてきました。情報収集のスピード化を継続することで、社外のメディアの方との信頼関係を築き、結果プレスリリース時なども大きく取り上げてもらえることができました。\nIR説明会では、投資家が疑問に思うポイントをとらえたプレゼンテーション資料を作成できるよう、リーダーとしてとりまとめをしてきました。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'research_shokumukeirekisho',
    title: 'リサーチ職の職務経歴書',
    description:
      'リサーチ職向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。リサーチ転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            'リサーチ会社にて、自動車、化粧品などの消費財メーカーの市場調査業務について、最適な調査手法や分析手法、分析ツールを組み合わせた調査プランの企画・実施の経験を有しております。実施後の結果の分析および結果に基づく提案プレゼンテーションまでのリサーチ業務全般も手がけてまいりました。'
        },
        { type: 'others', name: '', sentences: '' },
        { type: 'others', name: '', sentences: '' }
      ],
      prMessage: [
        {
          type: 'others',
          name: '提案力と迅速な対応をアピール',
          sentences:
            '○○○○株式会社に入社後、実査第一部に配属となり実査業務を○年経験してきました。そして、調査の分析スキル、提案スキルを高めるため、約○年間に渡り、様々な業界を対象にリサーチのプランニングから実査・集計・分析・レポート作成までの調査業務全般に従事してまいりました。特に、現在では化粧品についての調査に特化して担当をしております。提案力や迅速な対応により、クライアントから高い評価を頂き、担当を直接指名されることもしばしばありました。'
        },
        {
          type: 'others',
          name: 'マネジメント経験をアピール',
          sentences:
            '20xx年xx月からは、コンシューマチームの主任となり、数名のマネジメントも経験してきました。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'technology_shokumukeirekisho',
    title: 'メディカル・化学・食品開発系の職務経歴書',
    description:
      'メディカル・化学・食品開発系向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。メディカル・化学・食品開発系向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: 'MR',
          sentences:
            '主に抗うつ剤、降圧剤、血液凝固剤の名古屋・岐阜エリアのＭＲとして個人医院から総合病院まで幅広く担当してまいりました。新薬担当（抗菌剤）も○年間行いました。'
        },
        {
          type: 'others',
          name: '薬剤師',
          sentences:
            '院内・門前薬局にて薬剤師としての経験を豊富に有しております。現在は薬局店舗の店長として店舗運営全般のマネジメント業務にも携わっております。'
        },
        {
          type: 'others',
          name: '介護',
          sentences:
            '社会福祉法人○○でx年間、介護福祉士として常時xx人の利用者の介護を担当。利用者の日常生活の介助やレクリエーション、リハビリ、食事作り、リスクマネジメントなど幅広く業務を行ってきました。20xx年からはチームのリーダーとして後輩の指導・育成も担当しています。業務では、利用者が感じている不満をくみ取り、満足度向上に努めています。'
        }
      ],
      prMessage: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            '会社が不得意であった担当病院、会社に対してアンチであった顧客を担当し、逆風からのスタートも多かったですが、自分の強みであるポジティブさや、打ち解けていただけやすいところを生かし、顧客の性格・顧客ニーズを把握することで、人間関係の構築、症例獲得を多数経験してまいりました。\nまた、製品ラインナップから訪問診療所が多岐にわたり、各科での営業を経験することができました。営業所やチーム組織においては、自ら成功例・失敗例の共有化を図り、チーム・営業所の先輩方や同僚へのいい刺激を与え、組織全体への貢献も常に意識して行動をしておりました。'
        },
        {
          type: 'others',
          name: '熱意をアピール',
          sentences:
            '薬の相談は薬剤師へという思いのもと、患者と医師の診療の疎通をはかるため、一般病院にて○年勤務してまいりました。薬剤師の立場で、少しでも患者さんの気持ちが和らぐような対話と、正確にわかりやすく用法を伝える工夫をしてきましたが、このたび○○○○という新しい分野から薬にかかわってゆきたく転職を決意しました。\n新しい領域の仕事ですが、薬とその先の患者さんの病気を緩和させることに対する思いは誰にも負けないという自負がありますので、宜しくお願いいたします。'
        },
        {
          type: 'others',
          name: 'マネジメント力をアピール',
          sentences:
            '＜リーダーとしてのマネジメントスキル＞\nリーダーとして、適切な人員の配置や育成を心がけています。これまで無資格のベテランと有資格の若手スタッフが同じ業務を行い、業務効率の悪い状況が続いていました。また、新人の研修マニュアルなどもなく、人によって教え方が違うなどの問題が発生していました。対策として、有資格者には専門知識が必要な入浴介助や排泄介助などにできるだけ集中してもらったり、マニュアルを作成してそれを基に業務内容を覚えてもらったりしました。これら2つの取り組みによって、スタッフの満足度も向上しています。'
        },
        {
          type: 'others',
          name: '転職回数を逆手に取ってアピール',
          sentences:
            '私は、これまでに転職を5回経験いたしました。さまざまな介護施設に勤めてきただけに、経験してきた成功事例や失敗事例は人一倍多いと感じています。\\n介護施設によって、それぞれ利用者の要介護レベルはもちろん、設備の充実度なども異なります。そうした中で磨かれてきたのが、あらゆる場面で瞬時に状況を把握し、適切な対応を判断するスキルです。\n\n利用者の方々とそのご家族は、どういったケアを必要としているのか。そのことを常に考え、ケアを提供してきました。あらゆる場面で瞬時に状況を把握し、適切な対応を判断するスキルは、貴社においても活かせるものと考えております。\n\nこれまで培ってきた経験やスキルなどを貴社で活かしていきたいと思い、志望いたしました。'
        }
      ]
    }
  }),
  new FormatItem({
    id: 'pharmacist_shokumukeirekisho',
    title: '薬剤師の職務経歴書',
    description:
      '薬剤師向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。薬剤師向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            '院内・門前薬局にて薬剤師としての経験を豊富に有しております。現在は薬局店舗の店長として店舗運営全般のマネジメント業務にも携わっております。'
        },
        { type: 'others', name: '', sentences: '' },
        { type: 'others', name: '', sentences: '熱意をアピール' }
      ],
      prMessage: [
        {
          type: 'others',
          name: '薬の相談は薬剤師へという思いのもと、患者と医師の診療の疎通をはかるため、一般病院にて○年勤務してまいりました。薬剤師の立場で、少しでも患者さんの気持ちが和らぐような対話と、正確にわかりやすく用法を伝える工夫をしてきましたが、このたび○○○○という新しい分野から薬にかかわってゆきたく転職を決意しました。\n新しい領域の仕事ですが、薬とその先の患者さんの病気を緩和させることに対する思いは誰にも負けないという自負がありますので、宜しくお願いいたします。',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'physical_therapist_shokumukeirekisho',
    title: '理学療法士の職務経歴書',
    description:
      '理学療法士向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。理学療法士向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            '大学卒業後、〇〇病院で×年間、急性期病棟において、整形疾患および救急外来における術後の患者様のリハビリテーション業務に携わりました。\nまた、×年間は教育係として後輩育成にも関わりました。これまでの急性期での介入経験、後輩指導の経験を活かして貢献させていただければと考えております。'
        },
        { type: 'others', name: '', sentences: '' },
        { type: 'others', name: '', sentences: '' }
      ],
      prMessage: [
        {
          type: 'others',
          name: '疾患に関する幅広い知識をアピール',
          sentences:
            '救急外来では、合併症を有する患者様が多かったため、呼吸器や循環器疾患\nなど、様々な疾患に対するリハビリテーションに対応できる知識を身につけました。さらに、患者様にリハビリテーションを提供する上で、リスク管理の観点からも幅広い知識が求められ、広い視野で臨機応変に対応する力を身につけることができました。今後も患者様に対してより良い支援をするために、常に学ぶ姿勢ですべての業務に取り組んでいきたいです。'
        },
        {
          type: 'others',
          name: 'コミュニケーション能力をアピール',
          sentences:
            '病院内では医師や看護師など、多くの職種と連携を図りながら支援を行ってきました。スムーズな連携のために、他職種のスタッフ間との情報交換を欠かさず、どうすれば良いのかを相手の立場も踏まえて、常に考えながら業務に当たっていました。また、スタッフ間だけでなく、患者様や患者様のご家族に安心していただくために、明るい雰囲気でリハビリサービスを提供するように心がけています。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'occupational_therapist_shokumukeirekisho',
    title: '作業療法士の職務経歴書',
    description:
      '作業療法士向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。作業療法士向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            '大学を卒業後、〇〇病院に入職。チーム医療の一員として貢献。主に整形疾患、中枢神経疾患、呼吸器疾患に対するリハビリテーションを行う。'
        },
        { type: 'others', name: '', sentences: '' },
        { type: 'others', name: '', sentences: '' }
      ],
      prMessage: [
        {
          type: 'others',
          name: '患者様一人一人に寄り添えるアピール',
          sentences:
            '私が様々な疾患の患者様にリハビリを提供する時に心がけていたことは、\n患者様一人一人の気持ちに寄り添うことです。病気や怪我によって、今の生活や今後の生活に不安を抱える患者様を多く見てきました。そんな患者様が\nイキイキと自立した生活を送れるように、一人一人の想いをくみ取り、より意味のある支援ができるよう心がけています。'
        },
        {
          type: 'others',
          name: '様々な資格を持つアピール',
          sentences:
            '様々な疾患の患者様に対し、身体機能訓練・生活訓練から、ご家族への声かけ、介助指導など総合的に実施してきました。\n作業療法士としてさらに知識やスキルを身につけるために、認定作業療法士、呼吸療法認定士、認知症ケア専門士、福祉住環境コーディネータなどの資格を取得しました。貴社の実務に活かし貢献していきたいと考えています。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'speech_hearing_therapist_shokumukeirekisho',
    title: '言語聴覚療法士の職務経歴書',
    description:
      '言語聴覚療法士向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。言語聴覚療法士向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            '主に脳血管疾患後の言語・嚥下障害の患者様を担当してきました。回復期病棟から急性期病棟、維持期病棟まで患者様と深く関わることによって必要な支援を学んできました。医師、看護師、介護福祉士といった、他職種のスタッフと積極的にコミュニケーションをとり、サポートを行ってきました。'
        },
        { type: 'others', name: '', sentences: '' },
        { type: 'others', name: '', sentences: '' }
      ],
      prMessage: [
        {
          type: 'others',
          name: 'コミュニケーション能力をアピール',
          sentences:
            '患者様それぞれに合ったリハビリプログラムを考えるために、現在の状態はもちろんのこと、患者様の性格や趣味、これまで歩んできた人生まで理解することを心がけました。そのため、患者様やそのご家族とのコミュニケーションを密にとり、リハビリを進めることで、絆をさらに深めることができ、一人一人に寄り添った支援をすることができました。'
        },
        {
          type: 'others',
          name: '実行力をアピール',
          sentences:
            '看護師や栄養士と共に、口腔ケアや食事のレベルアップ基準などのマニュアルを作成し、全病棟に周知させることで、口腔衛生の向上や誤嚥リスクの早期発見に繋げることができました。また、理学療法士と共に復職を目標とした失語症患者様の職場までの通勤訓練や、作業療法士と共に職場へ同行しジョブコーチを行うなど様々なリハビリを提供しました。今後も、持ち前の実行力で、患者様に応じた質の高い支援を提供していきたいです。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'nutritionist_shokumukeirekisho',
    title: '栄養士の職務経歴書',
    description:
      '栄養士向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。栄養士向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            '大学卒業時に栄養士の資格を取得し、〇〇〇保育園に栄養士として就職。０～５歳児のお昼・おやつの調理・調整業務を実施しました。現在は献立作成・栄養価計算も担当しています。'
        },
        { type: 'others', name: '', sentences: '' },
        { type: 'others', name: '', sentences: '' }
      ],
      prMessage: [
        {
          type: 'others',
          name: 'コミュニケーション能力をアピール',
          sentences:
            '給食を提供する際に、利用者様に直接感想を聞くことで、調理業務や献立作成に活かすことを心がけてきました。\nまた、利用者様に楽しんで食事をしていただくために、イベントに合わせた行事食や季節の食材を取り入れた料理を提供してきました。実際に「食事の時間が楽しみ」とお声をいただき、とてもやりがいを感じております。\n今後も、利用者様に食を楽しんでいただけるように、健康で美味しい給食を提供していきたいと考えております。'
        },
        {
          type: 'others',
          name: '相手の立場になれることをアピール',
          sentences:
            '私の強みは、状況を把握し、常に相手のことを考えて行動できるところです。子供たちの食事中に、食が進んでいない場合はその原因を探り、次の献立メニューへ活かすようにしています。また、食育活動の企画では、子供たちに興味を持ってもらえるような季節行事を企画、実施しました。企画段階から保育士さんとも積極的に意見交換を行いました。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'construction_shokumukeirekisho',
    title: '各種施工管理技士（現場監督）の職務経歴書',
    description:
      '各種施工管理技士向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。各種施工管理技士向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            '株式会社○○○○○に入社後、現場係員として株式会社▽▽▽▽▽の単身寮建設工事を担当。工程管理の補助業務として、スケジュールや資材を管理。次に配属された株式会社△△△△△本社ビル建設工事の現場では、建設計画の作成を任され、主体的にスケジュール調整を担当しました。現在は大規模な商業施設の建設工事で全体の工程を管理しており、トラブルや事故が発生しないように密なコミュニケーションや人員管理に徹し、円滑な工事を進めています。'
        },
        { type: 'others', name: '', sentences: '' },
        { type: 'others', name: '', sentences: '' }
      ],
      prMessage: [
        {
          type: 'others',
          name: 'コミュニケーション能力をアピール',
          sentences:
            '＜計画どおりに工事を進める社内外とのコミュニケーション能力＞\n建設現場全体の工程管理担当として、計画どおりの円滑な工事のために、社内の現場作業員だけでなく社外の業者などとの密な連絡や報告に尽力しています。仮設工事や仕上げ工事など、各工事の担当者とこまめにスケジュールを調整して進捗共有しています。状況を細部まで把握することで、想定外のトラブルや事故の発生を防ぎ、計画どおりの建設に貢献してきました。'
        },
        {
          type: 'others',
          name: '管理能力をアピール',
          sentences:
            '＜徹底したスケジュール管理によるコスト削減＞\n建設計画策定の際は、調達する資材などの管理を徹底し無駄のないコスト配分を心掛けています。仮設、外装、内装といった各工事で必要な資材の使用スケジュールを管理し、余分な資材が出ないように発注を調整。また、資材だけでなく人員配置にも気を配り、各工程の工数を考慮して人数調整するなど生産性の向上に努めています。結果としてコスト削減につながり、自社の売り上げ拡大に貢献しました。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'driver_shokumukeirekisho',
    title: 'ドライバーの職務経歴書',
    description:
      'ドライバー向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。ドライバー向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            '専門学校を卒業後、○○○○株式会社にて小型トラックドライバー（3tトラック）として5年間従事し、相模原や八王子エリアのコンビニエンスストアへ菓子類や飲料の配送を担当してきました。自己管理と道路状況などの情報収集を丁寧に行い、入社以来、無事故・無違反を継続しています。'
        },
        {
          type: 'others',
          name: '自己管理力をアピール',
          sentences:
            'ルート配送トラックドライバーとして従事した3年間、事前のスケジュール管理や渋滞情報の調査を徹底して行うことによって、時間指定の荷物が多くある中でも焦ることのない安全運転を心がけ、結果として3年間の無事故無違反を継続しました。\n社として一日100件の配送が平均とされている中で、毎日運転前に入念なルート確認を行うことや迅速な行動を心がけることで効率化を図り、一日110件の配送を平均的に行うことに成功しました。\n体力には自信があり、お盆前といった暑い繁忙期でも体調を崩すことなく働くことができていました。貴社でもそのように信頼されるドライバーとして活躍したいと考えております。'
        },
        { type: 'others', name: '', sentences: '' }
      ],
      prMessage: [
        {
          type: 'others',
          name: '管理能力をアピール',
          sentences:
            '私は自動販売機へのルート配送を行うトラックドライバーに8年間従事し、飲料品の自動販売機を巡回し、商品補充や自販機の清掃・メンテナンス、売上金回収などの業務を行っています。この3年間はエリアリーダーを担当していて、新人への業務指導やチームメンバーのシフト管理なども行っております。5年の経験を活かしてエリアリーダーとなった時点で配送ルートの見直しを行い、新ルートの設定と渋滞時等の回避ルートを設定しました。さらに、荷積み順の効率化を徹底することで、チーム1人あたりの残業時間をX％削減することができました。トラック運転が好きで将来にわたってもトラックドライバーとして活躍したいと考え、大型トラックでの長距離配送へのステップアップを希望し、大型自動車第一種運転免許を取得しました。〇〇〇営業所を立ち上げ、長距離のトラックドライバーを急募している貴社でこれまでの経験を活かして即戦力として活躍いたします。'
        },
        {
          type: 'others',
          name: '自己管理力をアピール',
          sentences:
            '○○○○株式会社では入社当初、関東エリアのコンビニへ菓子類や飲料の配送を担当し、1回5〜6店（1日2回）を巡回。3年目からは八王子の広いエリアを任され、1回6〜8店（1日2回）の巡回を行ってきました。店舗への配送時間が決まっているので、事前に主要な幹線道路の渋滞状況を確認したり、トラブルや事故に巻き込まれないように車間距離を十分あけ、法定速度を守って運転するようにしたりしています。住宅街などを通ることが多く、子どもの飛び出しなどの危険もあるので、徐行運転と左右・前後の確認も徹底しています。\nまた仕事が忙しいときでも、7時間以上の睡眠を確保し、体調管理には気をつけています。アルコール・タバコも一切摂取しません。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'nursing_care_shokumukeirekisho',
    title: '介護職(介護福祉士)の職務経歴書',
    description:
      '介護職向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。介護職向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            '社会福祉法人○○でx年間、介護福祉士として常時xx人の利用者の介護を担当。利用者の日常生活の介助やレクリエーション、リハビリ、食事作り、リスクマネジメントなど幅広く業務を行ってきました。20xx年からはチームのリーダーとして後輩の指導・育成も担当しています。業務では、利用者が感じている不満をくみ取り、満足度向上に努めています。'
        },
        { type: 'others', name: '', sentences: '' },
        { type: 'others', name: '', sentences: '' }
      ],
      prMessage: [
        {
          type: 'others',
          name: 'マネジメント力をアピール',
          sentences:
            '＜リーダーとしてのマネジメントスキル＞\nリーダーとして、適切な人員の配置や育成を心がけています。これまで無資格のベテランと有資格の若手スタッフが同じ業務を行い、業務効率の悪い状況が続いていました。また、新人の研修マニュアルなどもなく、人によって教え方が違うなどの問題が発生していました。対策として、有資格者には専門知識が必要な入浴介助や排泄介助などにできるだけ集中してもらったり、マニュアルを作成してそれを基に業務内容を覚えてもらったりしました。これら2つの取り組みによって、スタッフの満足度も向上しています。'
        },
        {
          type: 'others',
          name: '転職回数を逆手に取ってアピール',
          sentences:
            '私は、これまでに転職を5回経験いたしました。さまざまな介護施設に勤めてきただけに、経験してきた成功事例や失敗事例は人一倍多いと感じています。\n\n介護施設によって、それぞれ利用者の要介護レベルはもちろん、設備の充実度なども異なります。そうした中で磨かれてきたのが、あらゆる場面で瞬時に状況を把握し、適切な対応を判断するスキルです。\n\n利用者の方々とそのご家族は、どういったケアを必要としているのか。そのことを常に考え、ケアを提供してきました。あらゆる場面で瞬時に状況を把握し、適切な対応を判断するスキルは、貴社においても活かせるものと考えております。\n\nこれまで培ってきた経験やスキルなどを貴社で活かしていきたいと思い、志望いたしました。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'dental_hygienist_shokumukeirekisho',
    title: '歯科衛生士の職務経歴書',
    description:
      '歯科衛生士向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。歯科衛生士向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '経験をアピール',
          sentences:
            '専門学校を卒業後、歯科衛生士を6年間経験してきました。○○○〇歯科医院では自費診療と保険診療を同程度対応しており、治療台がX台、一日の平均来院患者数は約XX名です。一般歯科のほか、歯周病治療やインプラントなど、さまざまな診療補助を経験してきました。'
        },
        { type: 'others', name: '', sentences: '' },
        { type: 'others', name: '', sentences: '' }
      ],
      prMessage: [
        {
          type: 'others',
          name: 'ブランクがあっても大丈夫！',
          sentences:
            'これまで〇ヵ所の歯科医院でキャリアを積んで参りましたが、平成〇年に結婚を機に退職し家庭に入っていましたが、子育ても落ち着いてきたため、将来を見直し転職活動中です。歯科衛生士の経験で培った、自然な対話の中から患者様のお悩みを引き出し、長期の信頼関係を構築できるスキルは貴院でも活かせると思っております。いま、通信講座で〇〇の勉強中です。再スタートからのチャレンジなので、厳しい環境であることは承知しております。何事も全力で集中し、ブランクを一刻も早く埋めるべくかんばりますので、どうぞよろしくお願いいたします。'
        },
        {
          type: 'others',
          name: 'データ入力の速さをアピール',
          sentences:
            '＜データ入力の速さを活かした仕事の効率化＞\nタイピングスキルを身につけて、時間のかかる業務の短縮を心がけています。タイピングの速さを活かして、連絡帳や保護者へのおたより、保育日誌を人一倍速く入力。ほかのスタッフが1クラス分の連絡帳を入力するのに1時間ほどかかっているところ、私の場合30分で入力することができます。加えて、過去1年間でブラインドタッチとショートカットを覚えたことによって、さらに事務処理の効率化につなげられています。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'childminder_shokumukeirekisho',
    title: '保育士の職務経歴書',
    description:
      '保育士向けA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。保育士向けの例文を参考に、転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: 'スキルをアピール',
          sentences:
            '社会福祉法人○○保育園に入職後、約x年間、x～x歳児 xx～xx名のクラスを担当しました。普段はクラス運営や保護者対応、各種行事の企画運営に携わっています。業務では、一人ひとりの家庭環境や性格をくみ取って接することで、園児・保護者と信頼関係を築けるよう心がけています。タイピングの速さを活かした各種書類の入力が得意で、仕事の効率化に努めています。'
        },
        { type: 'others', name: '', sentences: '' },
        { type: 'others', name: '', sentences: '' }
      ],
      prMessage: [
        {
          type: 'others',
          name: '信頼関係の構築力をアピール',
          sentences:
            '＜信頼関係の構築力＞\n保育園にはさまざまな家庭環境の子どもや保護者がいます。子どもを安心して預けてもらうためには、まず親御さんとの信頼関係を築くことがとても大切です。そこで、私は親御さんやご家族とコミュニケーションをとるときはまず傾聴して共感することを心がけました。また、保護者から質問されて答えられないことがあったときは、ほかのスタッフとも相談し、すべての園児・保護者に適切な対応ができるよう徹底。結果として保護者の方からもていねいな対応を感謝していただいています。'
        },
        {
          type: 'others',
          name: 'データ入力の速さをアピール',
          sentences:
            '＜データ入力の速さを活かした仕事の効率化＞\nタイピングスキルを身につけて、時間のかかる業務の短縮を心がけています。タイピングの速さを活かして、連絡帳や保護者へのおたより、保育日誌を人一倍速く入力。ほかのスタッフが1クラス分の連絡帳を入力するのに1時間ほどかかっているところ、私の場合30分で入力することができます。加えて、過去1年間でブラインドタッチとショートカットを覚えたことによって、さらに事務処理の効率化につなげられています。'
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'other_shokumukeirekisho',
    title: '一般的な職務経歴書',
    description:
      '一般的なA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: '',
          sentences:
            'はじめての転職\n大学卒業後、株式会社XXに入社。XX事業部・XX職として配属されました。主にXXを担当し、XXに関する業務やXXに携わってきました。'
        },
        {
          type: 'others',
          name: '',
          sentences:
            '2社の転職を経験\n大学を卒業後、新卒でXX会社に入社しXX職としてXX業界のXXに携わりました。2社目のXX社ではXX職としてXXやXXを担当、XXの経験を積みました。'
        },
        {
          type: 'others',
          name: '',
          sentences:
            '複数の転職を経験\n大学を卒業後、XX会社のXX職をX年勤めたのち、XX会社のXX職やXX会社のXX職を経験。20XX年より株式会社XXに入社し、XX職として勤務。主にXXに従事し、XXやXXの業務を担当しています。'
        }
      ],
      prMessage: [
        {
          type: 'others',
          name: '実行力をアピール',
          sentences:
            '私の強みは「実行力」です。\n現職ではパンフレットやチラシなどの印刷物を主に担当していましたが、前任者から引き継いだ時は、デザインは特定の制作会社にすべてお任せしていました。しかし、他社の制作物や制作会社の価格を調べるうちに、デザインや価格、サービスの妥当性に疑問を持ち、既存の制作会社を含めて相見積もりを行うことを社内に提案しました。\n自らリストアップし要件をまとめて制作依頼から社内調整まで進めました。結果的に、既存の制作会社よりも提案力があり、納期を柔軟に対応いただける会社を見つけることができました。コストも5％ほど削減しています。貴社業務でも、この経験を活かして貢献したいと考えております。'
        },
        {
          type: 'others',
          name: '柔軟性をアピール',
          sentences:
            '柔軟性を心掛け、「当たり前」を疑う姿勢を大切にしています。\n前職では役職者用のデスク・チェアを用意するのがルールとなっていましたが、異動や退職のたびに調整する手間やコストが発生していました。そのため、思い切って上司に提案し、全従業員の什器の規格を統一。他にも、小型冷蔵庫を導入して来客のお茶をペットボトルにしたり、若手を中心に不平の多かった社員旅行を近場での懇親会に変更したりと、従来の慣習によって負担となっていた手間やコストを改善しました。'
        },
        {
          type: 'others',
          name: '気配りをアピール',
          sentences:
            '社内外への気配りを大切にしています。\n司は非常に忙しく、日程調整のご依頼に対して、候補日がすべて予定で埋まっていることの方が多いのが課題でした。そこで、「〇日と〇日は大阪出張なので、〇時以降ならお取りできます」「〇曜日〇時の会議はいつも早く終わるので、〇時でいかがでしょうか」など、依頼者のニーズに合わせて候補をご提案していました。\nその結果、他の役員は調整に〇日程度かかるのが一般的ですが、△日程度で調整できるので、「〇〇さんはすぐに調整できて助かる」と言われます。また、こちらからご提案することで、メールのやり取りが減るので、業務も効率化することができました。'
        },
        {
          type: 'others',
          name: '計画性をアピール',
          sentences:
            '私の強みは「計画性」です。\n月末月初は入金確認と請求書発送などの業務が重なるため、業務量が少ない月の半ばに対象となる案件をリストアップし、Excelで進捗管理を行っていました。進捗管理表を運用することで、月末月初の業務量を可視化できるため、残業時間のコントロールも可能になりました。これまでの経験を活かして、貴社の業務に貢献したいと考えております。'
        }
      ]
    }
  }),
  new FormatItem({
    id: 'shokumukeirekisho',
    title: '職務経歴書',
    description:
      'A4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとに実績など一般的な項目が入力できます。転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    // thumbnail: '/static/img/formats/rirekisho_job_change.png',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: [
      // '/static/img/formats/sample/rirekisho_job_change_01.jpg',
      // '/static/img/formats/sample/rirekisho_job_change_02.jpg'
      '/static/img/formats/sample/shokurekisho.png'
    ],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: ['name', 'email'],
    hashs: ['職務経歴書'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    // cards: RirekishoCards,
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    // exampleSentences: jobChangeExampleSentences
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: 'はじめての転職',
          sentences:
            '大学卒業後、株式会社XXに入社。XX事業部・XX職として配属されました。主にXXを担当し、XXに関する業務やXXに携わってきました。'
        },
        {
          type: 'others',
          name: '2社の転職を経験',
          sentences:
            '大学を卒業後、新卒でXX会社に入社しXX職としてXX業界のXXに携わりました。2社目のXX社ではXX職としてXXやXXを担当、XXの経験を積みました。'
        },
        {
          type: 'others',
          name: '複数社の転職を経験',
          sentences:
            '大学を卒業後、XX会社のXX職をX年勤めたのち、XX会社のXX職やXX会社のXX職を経験。20XX年より株式会社XXに入社し、XX職として勤務。主にXXに従事し、XXやXXの業務を担当しています。'
        }
        // {type: 'others', name: 'エンジニア', sentences: '大学を卒業後、ソフトウェア開発会社に入社。一貫して金融業界の業務システム開発に携わる。1社目ではシステムエンジニアとしてプログラム基本設計から開発、テストをｘ年担当後、プロジェクトリーダーとしてプロジェクトの進捗管理を担当。2社目のシステムインテグレーターでは、加えて顧客折衝の経験を積む。'},
        // {type: 'others', name: '営業', sentences: '大学を卒業後、求人情報サイトを運営する株式会社◯◯に入社。営業職として、新規顧客の開拓を中心に取り組んでおりました。直近3年間は毎年目標売上を達成、昨年は120％達成により社内賞も受賞しました。チームリーダーを任されており、3名のチームメンバーの業績管理の経験もあります。'},
        // {type: 'others', name: '事務', sentences: '株式会社〇〇において、営業事務として5年間従事。営業担当8名の営業資料や契約書類の作成に加え、電話対応・来客対応・精算業務などに携わってきました。商品の知識を深めて営業担当とコミュニケーションをとることで、バックオフィスとの連携が円滑に回るようになり売上向上につながったと評価をいただきました。また、業務フローの整備や書類作成の簡略化など日々の業務の効率化にも取り組み、会社に貢献してきました。'},
        // {type: 'others', name: 'その他', sentences: '大学卒業後、株式会社〇〇に入社。XXといった業務に携わってきました。社外との折衝業務が多く、社内・外を問わず円滑なコミュニケーションを心掛けてきました。在職中はxxxxの資格を取得し、現在xxxxのスペシャリストを目指して勉強しております。今後は前職の経験を活かし、短期間で貴社の戦力となれるよう努力いたします。'}
      ],
      prMessage: [
        {
          type: 'others',
          name: 'スキルをアピール',
          sentences:
            '現職にてXXを目的としたXXに関わり、実務経験を積んできました。新しい技術や情報についても積極的に勉強し、チームのメンバーも交えて情報共有しながら実務で活かすように取り組んでいます。'
        },
        {
          type: 'others',
          name: '同業種・業界での経験をアピール',
          sentences:
            '現職では、XXメーカーのXX業務に長年携わっていました。ターゲットであるXXに適したXXなどの施策を実施し、前年対比XXX％の売上を達成しました。今までに学んできたXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
        },
        {
          type: 'others',
          name: 'マネジメント経験をアピール',
          sentences:
            '現職にてマネージャーをX年間経験し、社員が互いに刺激を与え合いながら成長していく組織作りに注力してきました。結果、社員同士の意識が目標に対して統一され、速やかな数値達成ができました。柔軟な対応力とXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
        },
        {
          type: 'others',
          name: '事務能力の高さ・効率性をアピール',
          sentences:
            'ケアレスミスをなくし、常に効率改善の余地がないか考えながら業務に取り組むように心がけています。現職では業務フローの見直しや日々の書類業務の自動化を主導し、全体の作業時間をXX％短縮させることに成功しました。特にXX関連業務の書類・ドキュメント作成の経験が豊富なことが強みです。'
        },
        {
          type: 'others',
          name: '意欲・熱意をアピール（実務未経験）',
          sentences:
            'XXがきっかけでXXという仕事に魅力を感じ、XXスクールやXX講座に通い自主的に勉強を続けてきました。今回、実務経験がなくても熱意や意欲次第で採用を検討されていると拝見し、応募をさせていただきました。未経験ではありますが、XXに関する知識やスキルを高める努力をしながら貴社の事業に貢献したいと考えています。'
        }
        // {type: 'others', name: 'エンジニア', sentences: '開発経験が豊富です。現職にて自社運営サイトのアクセス増加を目的とした新規機能開発に携わりました。サーバーサイドを担当し高速化・効率化を実現してきました。実務でのプログラミング経験から得た知識に加え、最近はプライベートでandroidアプリケーションの開発も行いました。新しい技術に関しても積極的に取り組んでいきます。チームマネジメント経験があります。少人数ながらチームリーダーを担当しました。メンバー間のコミュニケーションを重要視して円滑な進捗はもちろん、職務を通して全員がスキルアップしながら開発が行えるようマネジメントを心掛けました。'
        // },
        // {type: 'others', name: '営業', sentences: '前職では、エリアマネージャーを計5年経験しました。売上目標達成のため、店舗ごとに定期的に分析を行いKPIを設定。メンバーにはKPIとして設定したプロセスを完遂することを要望しました。その結果、目標を全て達成。売上目標も当初から20%増と推移し、非常に高い成果を残すことができました。扱う商材は変わりますが、お客様や店舗の状況を調査し戦略を立てた経験や、多数のメンバーのマネジメント経験は、貴社でも活かせるものと思います。'},
        // {type: 'others', name: '事務', sentences: '期限を守った上でミスなく確実にドキュメント作成を行ってきました。ダブルチェックを徹底し責任をもって仕事を仕上げます。また、常に効率改善の余地がないか考えながら日々の業務に取り組みます。前職では業務フローの見直しや日々の書類業務の自動化を主導し、全体の作業時間を大幅に短縮させることに成功しました。事務能力を活かして貴社に貢献したいと考えております。'},
        // {type: 'others', name: 'その他', sentences: '前職にてマネージャーを3年間経験しました。社員が互いに刺激を与え合いながら成長していく組織作りに注力してきました。結果として社員同士の意識が目標に対して統一され、速やかな数値達成ができました。柔軟な対応力と〇〇の経験を活かして、必ず貴社でお役に立てるものと考えております。何事も素直に吸収していけるよう、努力する気持ちを忘れずに頑張ります。'}
      ]
    }
  }),
  new FormatItem({
    id: 'english_resume',
    title: '英語の履歴書',
    description:
      '外資系企業や海外企業への応募に必須となる、標準的な英文レジュメのテンプレートです。日本の履歴書とは異なり、これまでの経歴やスキル、具体的な実績を簡潔にまとめて「自分がいかに即戦力であるか」を戦略的にアピールするための書類になります。',
    thumbnail: '/static/img/formats/english_resume.png',
    images: ['/static/img/formats/sample/english_resume.png'],
    newdetail1: 'A4サイズ/1枚',
    newdetail2: '',
    newdetail3: '外資系・海外企業向け',
    newdetail: '英文レジュメ',
    pagenumbs: '1枚',
    requiredBasicFields: ['name', 'birth', 'tel', 'email'],
    hashs: ['英語', '履歴書', 'レジュメ', 'resume', '外資'],
    components: {
      edit: EnglishResumeEdit,
      preview: EnglishResumePreview
    },
    cards: EnglishResumeCards,
    sampleData: EnglishResumeSample,
    exampleSentences: {}
  })
]

// if (process.env.VUE_APP_MODE !== 'production') {
//   formatsIndex.push(new FormatItem({
//     id: 'shokumukeirekisho',
//     title: '職務経歴書',
//     description: '（ベータ版）A4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとに実績など一般的な項目が入力できます。転職活動などでお使いください。',
//     // thumbnail: '/static/img/formats/rirekisho_job_change.png',
//     thumbnail: '/static/img/formats/shokurekisho-min.png',
//     images: [
//       // '/static/img/formats/sample/rirekisho_job_change_01.jpg',
//       // '/static/img/formats/sample/rirekisho_job_change_02.jpg'
//       '/static/img/formats/sample/shokurekisho.png'
//     ],
//     requiredBasicFields: ['name'],
//     hashs: ['職務経歴書', '転職'],
//     components: {
//       edit: ShokurekishoEdit,
//       preview: ShokurekishoPreview
//     },
//     // cards: RirekishoCards,
//     cards: ShokurekiCards,
//     sampleData: ShokurekishoSample,
//     // exampleSentences: jobChangeExampleSentences
//     exampleSentences: {
//       summary: [
//         {type: 'others', name: 'はじめての転職', sentences: '大学卒業後、株式会社XXに入社。XX事業部・XX職として配属されました。主にXXを担当し、XXに関する業務やXXに携わってきました。'},
//         {type: 'others', name: '2社の転職を経験', sentences: '大学を卒業後、新卒でXX会社に入社しXX職としてXX業界のXXに携わりました。2社目のXX社ではXX職としてXXやXXを担当、XXの経験を積みました。'},
//         {type: 'others', name: '複数社の転職を経験', sentences: '大学を卒業後、XX会社のXX職をX年勤めたのち、XX会社のXX職やXX会社のXX職を経験。20XX年より株式会社XXに入社し、XX職として勤務。主にXXに従事し、XXやXXの業務を担当しています。'}
//         // {type: 'others', name: 'エンジニア', sentences: '大学を卒業後、ソフトウェア開発会社に入社。一貫して金融業界の業務システム開発に携わる。1社目ではシステムエンジニアとしてプログラム基本設計から開発、テストをｘ年担当後、プロジェクトリーダーとしてプロジェクトの進捗管理を担当。2社目のシステムインテグレーターでは、加えて顧客折衝の経験を積む。'},
//         // {type: 'others', name: '営業', sentences: '大学を卒業後、求人情報サイトを運営する株式会社◯◯に入社。営業職として、新規顧客の開拓を中心に取り組んでおりました。直近3年間は毎年目標売上を達成、昨年は120％達成により社内賞も受賞しました。チームリーダーを任されており、3名のチームメンバーの業績管理の経験もあります。'},
//         // {type: 'others', name: '事務', sentences: '株式会社〇〇において、営業事務として5年間従事。営業担当8名の営業資料や契約書類の作成に加え、電話対応・来客対応・精算業務などに携わってきました。商品の知識を深めて営業担当とコミュニケーションをとることで、バックオフィスとの連携が円滑に回るようになり売上向上につながったと評価をいただきました。また、業務フローの整備や書類作成の簡略化など日々の業務の効率化にも取り組み、会社に貢献してきました。'},
//         // {type: 'others', name: 'その他', sentences: '大学卒業後、株式会社〇〇に入社。XXといった業務に携わってきました。社外との折衝業務が多く、社内・外を問わず円滑なコミュニケーションを心掛けてきました。在職中はxxxxの資格を取得し、現在xxxxのスペシャリストを目指して勉強しております。今後は前職の経験を活かし、短期間で貴社の戦力となれるよう努力いたします。'}
//       ],
//       prMessage: [
//         {type: 'others', name: 'スキルをアピール', sentences: '現職にてXXを目的としたXXに関わり、実務経験を積んできました。新しい技術や情報についても積極的に勉強し、チームのメンバーも交えて情報共有しながら実務で活かすように取り組んでいます。'
//         },
//         {type: 'others', name: '同業種・業界での経験をアピール', sentences: '現職では、XXメーカーのXX業務に長年携わっていました。ターゲットであるXXに適したXXなどの施策を実施し、前年対比XXX％の売上を達成しました。今までに学んできたXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
//         },
//         {type: 'others', name: 'マネジメント経験をアピール', sentences: '現職にてマネージャーをX年間経験しまし、社員が互いに刺激を与え合いながら成長していく組織作りに注力してきました。結果、社員同士の意識が目標に対して統一され、速やかな数値達成ができました。柔軟な対応力とXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
//         },
//         {type: 'others', name: '事務能力の高さ・効率性をアピール', sentences: 'ケアレスミスをなくし、常に効率改善の余地がないか考えながら業務に取り組むように心がけています。現職では業務フローの見直しや日々の書類業務の自動化を主導しまし、全体の作業時間をXX％短縮させることに成功しました。特にXX関連業務の書類・ドキュメント作成の経験が豊富なことが強みです。'
//         }
//         // {type: 'others', name: 'エンジニア', sentences: '開発経験が豊富です。現職にて自社運営サイトのアクセス増加を目的とした新規機能開発に携わりました。サーバーサイドを担当し高速化・効率化を実現してきました。実務でのプログラミング経験から得た知識に加え、最近はプライベートでandroidアプリケーションの開発も行いました。新しい技術に関しても積極的に取り組んでいきます。チームマネジメント経験があります。少人数ながらチームリーダーを担当しました。メンバー間のコミュニケーションを重要視して円滑な進捗はもちろん、職務を通して全員がスキルアップしながら開発が行えるようマネジメントを心掛けました。'
//         // },
//         // {type: 'others', name: '営業', sentences: '前職では、エリアマネージャーを計5年経験しました。売上目標達成のため、店舗ごとに定期的に分析を行いKPIを設定。メンバーにはKPIとして設定したプロセスを完遂することを要望しました。その結果、目標を全て達成。売上目標も当初から20%増と推移し、非常に高い成果を残すことができました。扱う商材は変わりますが、お客様や店舗の状況を調査し戦略を立てた経験や、多数のメンバーのマネジメント経験は、貴社でも活かせるものと思います。'},
//         // {type: 'others', name: '事務', sentences: '期限を守った上でミスなく確実にドキュメント作成を行ってきました。ダブルチェックを徹底し責任をもって仕事を仕上げます。また、常に効率改善の余地がないか考えながら日々の業務に取り組みます。前職では業務フローの見直しや日々の書類業務の自動化を主導し、全体の作業時間を大幅に短縮させることに成功しました。事務能力を活かして貴社に貢献したいと考えております。'},
//         // {type: 'others', name: 'その他', sentences: '前職にてマネージャーを3年間経験しました。社員が互いに刺激を与え合いながら成長していく組織作りに注力してきました。結果として社員同士の意識が目標に対して統一され、速やかな数値達成ができました。柔軟な対応力と〇〇の経験を活かして、必ず貴社でお役に立てるものと考えております。何事も素直に吸収していけるよう、努力する気持ちを忘れずに頑張ります。'}
//       ]
//     }
//   }))
// }
export default formatsIndex
